<template>
    <section id="product">
        <loading :active.sync="is_loading"></loading>
        <div id="breadcrumbs">
            <div class="bg-light py-3">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 mb-0">
                            <div class="text-left">
                                <router-link to="/">Inicio</router-link>
                                <span class="mx-2 mb-0">/</span>
                                <strong class="text-black">{{ productCart.item_name }}</strong>
                            </div>
                        </div>
                    </div>
                    <!-- .row -->
                </div>
                <!-- .container -->
            </div>
            <!-- .bg-light -->
        </div>
        <!-- #breadcrumbs -->
        <div class="site-section py-3">
            <!-- aqui va el estilo de la seleccion-->
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="product-img">
                            <img class="img-fluid" :src="productImage" :alt="productCart.item_name" v-show="productGallery.length === 0"/>
                            <carousel :autoplay="true" :per-page="1" :loop="true" :navigationEnabled="false" :speed="1000" paginationActiveColor="#f04150" paginationColor="#0F182B" v-show="productGallery.length > 0">
                                <slide>
                                    <img :src="productImage" alt="" class="img-fluid baja-mobile">
                                </slide>
                                <slide v-for="(slide, index) in productGallery" :key="index">
                                    <img :src="slide.image" alt="Product Slide" class="img-fluid baja-mobile">
                                </slide>
                            </carousel>
                        </div>
                        <p class="mt-4">
                            <strong class="h1 text-blue"
                            >${{ productCart.price * productCart.quantity }}</strong
                            >
                        </p>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="product-container text-left">
                            <h2 class="text-black">{{ productCart.item_name }}</h2>
                            <p v-html="productCart.item_description"></p>
                            <p class="mb-5">Opciones de pago: tarjeta de crédito, débito y Paypal</p>
                            <!-- <div v-if="attributes" class="mb-2">
                                <select
                                    name="attribute"
                                    class="form-control"
                                    v-model="attributeSelected"
                                >
                                    <option value="">.: Selecciona color :.</option>
                                    <option
                                        :value="color"
                                        v-if="attributes.atts != undefined"
                                        v-for="color in attributes.atts.Color"
                                        :key="color"
                                    >
                                        {{ color }}
                                    </option>
                                </select>
                            </div> -->

                            <span>Precio:</span>
                            <select
                                id="product_prices"
                                name="prices"
                                v-model="productPrice"
                                class="form-control"
                            >
                                <option value="">.: Selecciona precio del producto :.</option>
                                <option
                                    :value="price"
                                    v-for="(price, index) in prices"
                                    :key="index"
                                >
                                    {{ price.description }} (${{ price.price }})
                                </option>
                            </select>
                            <div class="mb-2 mt-2 mt-sm-3">
                                <span class="pr-3">Cantidad:</span>
                                <div class="input-group" style="max-width: 120px; display:inline-flex;">
                                    <div class="input-group-prepend">
                                        <button
                                            v-if="productCart.type_id !== 3 && productCart.type_id !== 6 && productCart.type_id !== 7"
                                            class="btn btn-outline-primary"
                                            type="button"
                                            @click="minusQuantity"
                                        >
                                            &minus;
                                        </button>
                                    </div>
                                    <input
                                        type="text"
                                        class="form-control text-center"
                                        v-model="productCart.quantity"
                                        placeholder=""
                                        readonly
                                    />
                                    <div class="input-group-append">
                                        <button
                                            v-if="productCart.type_id !== 3 && productCart.type_id !== 6 && productCart.type_id !== 7"
                                            class="btn btn-outline-primary"
                                            type="button"
                                            @click="plusQuantity"
                                        >
                                            &plus;
                                        </button>
                                    </div>
                                </div>
                                <!-- <div v-if="productCart.type_id == 3 || productCart.type_id == 6 || productCart.type_id == 7">
                                    <b-button
                                        v-b-modal.modal-1
                                        v-show="validateDelight"
                                        class="mt-3 buy-now btn btn-default btn-lg border border-dark text-light mx-auto"
                                        style="background: #0F182B"
                                    >
                                        COMPRA YA EN 1 CLIC
                                    </b-button>
                                    <b-button
                                        v-b-modal.modal-1
                                        v-show="productCart.type_id === 6 || productCart.type_id === 7 || productCart.id === 108 || productCart.id === 85 || productCart.id === 86"
                                        class="mt-3 buy-now btn btn-default btn-lg border border-dark text-light mx-auto"
                                        style="background: #0F182B"
                                    >
                                        COMPRA YA EN 1 CLIC
                                    </b-button>
                                </div> -->
                                <div  v-if="productCart.type_id == 3 || productCart.type_id == 6 || productCart.type_id == 7">
                                    <b-button
                                    v-if="validateDelight"
                                    class="mt-3 buy-now btn btn-default btn-lg border border-dark text-light d-block"
                                    @click="addToCart"
                                    v-b-modal.modal-1
                                    style="background: #0f182b"
                                >
                                    Agregar al carrito
                                </b-button>
                                <b-button
                                    v-else
                                    class="mt-3 buy-now btn btn-default btn-lg border border-dark text-light d-block"
                                    @click="addToCart"
                                    style="background: #0f182b"
                                >
                                    Agregar al carrito
                                </b-button>

                                </div>
                                <div v-else>
                                    <b-button
                                    class="mt-3 buy-now btn btn-default btn-lg border border-dark text-light d-block"
                                    @click="addToCart"
                                    style="background: #0f182b"
                                >
                                    Agregar al carrito
                                </b-button>
                                </div>
                                <b-modal
                                    ref="modal-1"
                                    hide-footer
                                    id="modal-1"
                                    title="¡Elige!"
                                    @hide="closeModal"
                                >
                                    <div class="delight-selection" v-show="!(productCart.type_id == 6)">
                                        <p class="my-4 text-center font-weight-bold">
                                            ¿Estás seguro que no deseas agregar una alegría?
                                        </p>
                                        <!-- <button
                                          @click="$snotify.warning('Agrega la alegría a tu carrito')"
                                          class="buy-now btn btn-default btn-lg border border-dark text-light mx-auto"
                                          style="background: #0f182b; width: 100%"
                                        >
                                          ¡Si Quiero!
                                        </button> -->
                                        <DelightSelection
                                            @click="addDelightToProduct"
                                        ></DelightSelection>
                                        <button
                                            @click="hideModalDelight"
                                            class="buy-now btn btn-default btn-lg border border-dark text-dark mx-auto"
                                            style="width: 100%"
                                        >
                                            No quiero
                                        </button>
                                    </div>
                                    <div class="modal-selection" v-show="is_guest || productCart.type_id == 6">
                                        <h4 style="font-weight: bold;
				background: rgb(255, 255, 255);
				color: rgb(240, 65, 80);
				border-radius: 12px;
				border-color: white;
				text-align:center; margin-top:30px;">Continuar como</h4>
                                        <div class="mt-4 d-flex justify-content-between">
                                            <button type="button" class="btn btn text-light btn-secondary d-inline "
                                                    style="background: rgb(15, 24, 43); font-weight: bold; width: 175px; height: 40px;"
                                                    @click="accessAsGuest">
                                                <span>Invitado</span>
                                            </button>
                                            <button type="button" class="btn btn text-light btn-secondary d-inline"
                                                    style="background: rgb(15, 24, 43); font-weight: bold; width: 175px; height: 40px;"
                                                    @click="showModalLogin" >
                                                <span>Iniciar sesión</span>
                                            </button>
                                        </div>
                                    </div>
                                </b-modal>
                            </div>
                            <div v-if="is_subscription">
                                <DelightSelection
                                    :validate="validateDelight"
                                    @modify="modifyVerificationDelight"
                                    @click="addDelightToProduct"
                                ></DelightSelection>
                            </div>
                        </div>
                    </div>
                </div>
                <LoginForm ref="login"></LoginForm>
                <SimilarProduct :similarProducts="similarProducts" />
            </div>
        </div>
    </section>
</template>

<script>
// @ is an alias to /src
import Loading from "vue-loading-overlay";
import SimilarProduct from "../components/SimilarProduct.vue";
//import "vue-loading-overlay/dist/vue-loading.css";
import DelightSelection from "@/components/DelightSelection.vue";
import { Carousel, Slide } from "vue-carousel";
import LoginForm from "@/components/LoginForm";
const axios = require("axios");

export default {
    name: "product",
    components: {
        Loading,
        DelightSelection,
        SimilarProduct,
        Carousel,
        Slide,
        LoginForm,
    },
    data() {
        return {
            api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
            base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
            productCart: {
                id: null,
                item_name: null,
                item_description: null,
                quantity: 1,
                attribute: null,
                price: 0,
                priceObj: null,
                delight: null,
                type_id: null,
                is_recurrency: false,
            },
            productImage: "",
            productPrice: 0,
            prices: null,
            is_subscription: false,
            is_sams_product: false,
            attributes: [],
            attributeSelected: "",
            haveAttributesFilter: true,
            is_loading: true,
            similarProducts: [],
            typeProductId: null,
            allProdducts: null,
            validateDelight: false,
            validateModalDelight: false,
            productGallery: [],
            is_guest: false,
            guestUser: false,
            guestAccess: false,
            typeUser: "",
            userId: $cookies.get('uidmmkg')
        };
    },
    props: ["id"],
    created() {
        this.getAllProducts();

        if ($cookies.isKey("utoken")) {
            this.typeUser = "El usuario esta logeado"
        }
        else{
            this.typeUser = "El usuario es invitado"
        }
        console.log(this.typeUser);
    },
    watch: {
        productPrice: function (newPrice, oldPrice) {
            this.productCart.price = newPrice.price;
            this.productCart.priceObj = newPrice;
        },
        attributeSelected: function (newValue, oldValue) {
            this.productCart.attribute = newValue;
            this.haveAttributesFilter = true;
        },
    },
    filters: {
        fullUrl: function (file) {
            return file;
        },
    },
    methods: {
        closeModal: function(){
            //  this.validateModalDelight = true;
            //  this.addToCart();
        },
        getAllProducts: function () {
            axios({
                method: "GET",
                url: this.api_url + "/products",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + $cookies.get("ctoken"),
                },
            })
                .then((response) => {
                    this.allProdducts = response.data;
                    console.log("Se obtienen todos los productos: ", response.data);
                    this.loadProduct();
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        baseUrlImage: function (file) {
            return this.base_url + "/storage/upload/" + file;
        },
        loadProducts: function () {
            if (this.allProdducts){
                this.allProdducts.forEach((producto) => {
                    if (producto.product_type_id.id === this.typeProductId && producto.is_active) {
                        if (producto.name !== this.productCart.item_name) {
                            this.similarProducts.push(producto);
                        }
                    }
                });
            }
        },
        loadProduct: function () {
            if ($cookies.get("ctoken")) {
                axios({
                    method: "GET",
                    url: this.api_url + "/products/" + this.id,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + $cookies.get("ctoken"),
                    },
                })
                    .then((response) => {
                        console.info("Se obtiene producto: ", response.data.data);
                        this.loadPrices(response.data.data);
                        // Cargando datos al producto para carrito
                        this.productCart.id = response.data.data.id;
                        this.productCart.item_name = response.data.data.name;
                        this.productCart.item_description = response.data.data.description;
                        this.productCart.type_id = response.data.data.product_type_id.id;
                        this.productImage = response.data.data.big_picture;
                        this.attributes = response.data.data.attribute;
                        this.typeProductId = response.data.data.product_type_id.id;
                        this.productGallery = response.data.gallery;


                        window.dataLayer.push({
                          'event': 'VisualizacionProducto',
                          'pageURL': this.$router.currentRoute.fullPath,
                          'product': response.data.data,
                          'dateVisit': new Date().toLocaleString('en-US')
                        });

                        this.loadProducts();

                        if (response.data.data.product_type_id.id == 3) {
                            this.is_subscription = true;
                            console.info("Es suscripcion se agrega la recurrencia");
                            this.productCart.is_recurrency == true;
                        }
                        if (response.data.data.product_type_id.id == 6){
                            console.info("Es suscripcion digital se agrega la recurrencia");
                            this.productCart.is_recurrency == true;
                        }
                        if (response.data.data.product_type_id.id == 7){
                            if(response.data.data.id == 108 || response.data.data.id == 85 || response.data.data.id == 86 ||
                                response.data.data.id == 113){
                                console.info("Es suscripcion especial");
                                this.productCart.is_recurrency == true;
                            }
                        }
                        //Agregar  e ciertos productos para que tengan alegria
                        if(response.data.data.id == 108 || response.data.data.id == 86 || response.data.data.id == 85){
                            this.validateDelight =  true;
                        }

                        if (response.data.data.id == 108 || response.data.data.id == 85 || response.data.data.id == 86){
                            this.is_sams_product == true;
                        }
                        if (response.data.data.attribute) {
                            this.haveAttributesFilter = false;
                        }

                        this.is_loading = false;
                    })
                    .catch((error) => {
                        console.error(error);
                        this.is_loading = false;
                    });
            } else {
                console.info("No se encontro la cookie");
                this.is_loading = false;
            }
        },
        loadPrices: function (product) {
            this.prices = product.prices;
            console.info("Precio del producto: ", this.prices);
            // Preseleccionamos el primer precio cuando se cargan los precios al combo
            if (this.prices.length > 0){
                this.productCart.price = this.prices[0].price;
                this.productCart.priceObj = this.prices[0];
                this.productPrice = this.prices[0];
            }
        },
        minusQuantity: function () {
            if (this.productCart.quantity > 0) {
                this.productCart.quantity--;
            }
        },
        plusQuantity: function () {
            this.productCart.quantity++;
        },
        addToCart: function () {
            if (
                this.validateDelight &&
                this.productCart.delight == null &&
                !this.validateModalDelight
            ) {
                return null;
            } else {
                this.addProductToCart();
                // if (this.productCart.type_id == 3 || this.productCart.type_id == 6 || this.productCart.type_id == 7){
                //     this.addToCartSubscription()
                // }else{
                //     this.addProductToCart();
                // }
            }
        },
        addProductToCart: function(){
            if (
                this.haveAttributesFilter === true &&
                this.productCart.id &&
                this.productCart.item_name &&
                this.productCart.price > 0 &&
                this.productCart.quantity > 0
            ) {
                if (this.productCart.price > 40 && this.productPrice != 0) {
                    // Se agrega el product elegido al carrito
                    if (this.productCart.type_id == 3 || this.productCart.type_id == 6){
                        this.productCart.is_recurrency = true;
                    }
                    if (this.productCart.type_id == 7){
                        if(this.productCart.id == 108 || this.productCart.id == 85 || this.productCart.id == 86 || this.productCart.id == 113){
                            this.productCart.is_recurrency = true;
                        }
                    }
                    console.info("Data del producto a agregar al carrito");
                    console.info(this.productCart);
                    this.$store.commit("addProductCart", this.productCart);
                    this.$snotify.success("Se agregó su producto al carrito");

                    // Agregando datos de carrito a el servidor
                    // if($cookies.get("utoken")){
                    //     axios({
                    //         method: "POST",
                    //         url: this.api_url + "/cart/store",
                    //         headers: { 
                    //         "Content-Type": "application/json",
                    //         Authorization: "Bearer " + $cookies.get("ctoken"),
                    //         },
                    //         data:{
                    //             user_id: this.userId,
                    //             items: [this.productCart]
                    //         }
                    //     })
                    //     .then((response) => {
                    //         if(response.data.status){
                    //         console.error("agregando este producto a el servidor", response.data);
                    //         }
                    //         else{
                    //         console.log(response.data.message);
                    //         }
                    //     })
                    //     .catch((error) => {
                    //         console.error(error);
                    //     })
                    // }


                    window.dataLayer.push({
                      'event': 'ProductoAgregadoCarrito',
                      'pageURL': this.$router.currentRoute.fullPath,
                      'product': this.productCart,
                      'dateVisit': new Date().toLocaleString('en-US')
                    });

                    this.$router.push({ name: "cart" });
                } else {
                    this.$snotify.warning("Se debe de elegir el precio del producto");
                }
            } else {
                this.$snotify.warning("Faltan datos del producto");
            }
        },
        addDelightToProduct: function (delight) {
            console.info("Agregando alegria al producto en la vista");
            this.productCart.delight = delight;
            this.productCart.price = this.productCart.price;
            // this.productCart.price + this.productCart.delight.prices[0].price;
            this.productCart.delight_id = this.productCart.delight.id;
            this.hideModalDelight();
        },
        modifyVerificationDelight: function (param) {
            this.validateDelight = param;
        },
        hideModalDelight() {
            this.validateModalDelight = true;
            this.addToCart();
        },
        selectedProduct: function(id){
        },
        accessAsGuest: function(){
            this.guestAccess = true;
            console.log('ingresaste como invitado');
            this.guestUser = true;
            this.$refs['modal-1'].hide();
        },
        showModalLogin: function(){
            this.guestAccess = true;
            console.log('inicia sesion');
            this.$refs['modal-1'].hide();
            this.$refs.login.showModal(this.productCart);
        },
        addToCartSubscription: function(){
            console.log(this.productCart);
            this.is_loading = true;
            if(this.validateDelight && this.productCart.delight == null && !this.validateModalDelight){
                return null;
            }else{
                if(this.productCart.id &&
                    this.productCart.item_name &&
                    this.productCart.price > 0 &&
                    this.productCart.quantity > 0){

                    if(this.productCart.price > 40 && this.productPrice != 0){
                        if (this.productCart.type_id == 3 || this.productCart.type_id == 6 ){
                            this.productCart.is_recurrency = true;
                        }
                        if (this.productCart.type_id == 7 ){
                            if(this.productCart.id == 108 || this.productCart.id == 85 || this.productCart.id == 86 || this.productCart.id == 113){
                                this.productCart.is_recurrency = true;
                            }
                        }
                        if(this.guestUser){
                            this.$router.push({name: "guestCheckoutSubscriptions", params: this.productCart});
                            console.log('accediste como invitado');
                            this.$store.commit('addProductCartSubscription', this.productCart);
                            console.info('se agrego la suscripcion');
                            this.is_loading = false;
                        }
                        if ($cookies.get("utoken")) {
                            this.$router.push({name: "checkoutSubscription", params: this.productCart});
                            console.log('usuario logeado');
                            console.info('se agrego la suscripcion');
                            console.log(this.productCart);
                            this.$store.commit('addProductCartSubscription', this.productCart);
                            this.is_loading = false;
                        }
                        else{
                            console.error("error");
                            this.is_loading = false;
                            this.is_guest = true;
                            console.log('usuario no logeado');
                            return false;
                        }
                    }
                    else {
                        this.$snotify.warning("Se debe de elegir el precio del producto");
                    }
                }
                else{
                    this.$snotify.warning("Faltan datos del producto");
                }
            }
        },
    },
};
</script>
